import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuard } from './guards/admin.guard';
import { AuthGuard } from './guards/auth.guard';
import { HomeComponent } from './components/home/home.component';
import { LibraryComponent } from './components/library/library.component';
import { ModuleFormComponent } from './components/module-form/module-form.component';
import { ModuleResponsesComponent } from './components/module-responses/module-responses.component';
import { ModuleComponent } from './components/module/module.component';
import { NodeFormComponent } from './components/node-form/node-form.component';
import { SettingsComponent } from './components/settings/settings.component';
import { PresenterGuard } from './guards/presenter.guard'
import { AdminComponent } from './components/admin/admin.component';

const routes: Routes = [
  {
    path: '', 
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home', 
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'home/:parent', 
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'module/:id',
    component: ModuleComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'moduleAdd/:institutionId/:nodeId',
    component: ModuleFormComponent,
    canActivate: [AuthGuard, PresenterGuard]
  },
  {
    path: 'moduleEdit/:moduleId',
    component: ModuleFormComponent,
    canActivate: [AuthGuard, PresenterGuard]
  },
  {
    path: 'nodeAdd/:institutionId',
    component: NodeFormComponent,
    canActivate: [AuthGuard, PresenterGuard]
  },
  {
    path: 'nodeAdd/:institutionId/:parentNodeId',
    component: NodeFormComponent,
    canActivate: [AuthGuard, PresenterGuard]
  },
  {
    path: 'nodeEdit/:nodeId',
    component: NodeFormComponent,
    canActivate: [AuthGuard, PresenterGuard]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'library',
    component: LibraryComponent,
    canActivate: [AuthGuard, PresenterGuard]
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AdminGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
